<template>
    <div
        class="row form-group align-items-center justify-content-between group_wrapper"
    >
        <div class="col-4 p-0 group_column">
            <div class="col-12 form-group">
                <label>Full name</label>

                <input
                    v-model="person.fullName"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('fullName')
                    }"
                    dir="auto"
                />
            </div>

            <div class="col-12 form-group">
                <label>Email</label>

                <input
                    v-model="person.email"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('email')
                    }"
                    dir="auto"
                />
            </div>

            <div class="col-12 form-group">
                <label>Position</label>

                <input
                    v-model="person.position"
                    type="text"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('position')
                    }"
                    dir="auto"
                />
            </div>
        </div>

        <div class="col-6">
            <div class="col-12 form-group">
                <label>Image</label>

                <media-chooser
                    v-model="person.imageId"
                    type="image"
                    id-only
                    :error-border="hasError('imageId')"
                />
            </div>
        </div>

        <div class="col-1 p-0 mr-4 form-group">
            <div class="col-12">
                <h6 class="p-2 bg-light text-center text-uppercase">
                    #{{ index + 1 }}
                </h6>
            </div>

            <button class="col-12 handle btn btn-info mb-4 mt-4">
                <i class="fas fa-arrows-alt" />
            </button>

            <button
                class="col-12 btn btn-danger mb-4 mt-4"
                type="button"
                @click="$emit('remove')"
            >
                <i class="far fa-trash-alt" />
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        v: {
            type: Object,
            required: false,
            default: () => ({})
        },
        index: {
            type: Number,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            person: {}
        };
    },

    watch: {
        person() {
            this.$emit('input', this.person);
        }
    },

    mounted() {
        this.person = { ...this.value, order: this.index };
    },

    methods: {
        hasError(key) {
            return (
                this.v.users.$each[this.index][key]?.$error ||
                this.serverErrors.find(error =>
                    error.param.includes(`users[${this.index}].${key}`)
                )
            );
        }
    }
};
</script>
